{
    "FormEngineCheckboxElement": {
        "title": "Checkbox"
    },
    "mask": {
        "FormEngineCheckboxElement": {
            "groupTitle": "Checkbox",
            "inline": "Inline",
            "datasource": "Options",
            "datasourceExpressions": "Options Filter",
            "nested": "Nested",
            "nestedGroupOptions": "Options Key",
            "nestedGroupLabel": "Group Label"
        }
    }
}